var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethodType["DEBT_COLLECTION_AGENCY"] = "DEBT_COLLECTION_AGENCY";
    PaymentMethodType["DISCOUNT"] = "DISCOUNT";
    PaymentMethodType["APPLE_PAY"] = "APPLE_PAY";
    PaymentMethodType["ACH_BANK_ACCOUNT"] = "ACH_BANK_ACCOUNT";
    PaymentMethodType["CASH_APP_PAY"] = "CASH_APP_PAY";
})(PaymentMethodType || (PaymentMethodType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["PAD"] = "PAD";
    PaymentType["PBI"] = "PBI";
    PaymentType["PCL"] = "PCL";
})(PaymentType || (PaymentType = {}));
var TopazStatus;
(function (TopazStatus) {
    TopazStatus[TopazStatus["Initial"] = 0] = "Initial";
    TopazStatus[TopazStatus["Saving"] = 1] = "Saving";
    TopazStatus[TopazStatus["Saved"] = 2] = "Saved";
    TopazStatus[TopazStatus["DuplicateCard"] = 3] = "DuplicateCard";
    TopazStatus[TopazStatus["InvalidDetails"] = 4] = "InvalidDetails";
    TopazStatus[TopazStatus["ExceededMaxAttemptsEnteringDetails"] = 5] = "ExceededMaxAttemptsEnteringDetails";
    TopazStatus[TopazStatus["InvalidState"] = 6] = "InvalidState";
    TopazStatus[TopazStatus["InvalidShippingDetails"] = 7] = "InvalidShippingDetails";
    TopazStatus[TopazStatus["Error"] = 8] = "Error";
})(TopazStatus || (TopazStatus = {}));
var isSavedCard = function (paymentMechanism) { return 'token' in paymentMechanism; };
var isNewCard = function (paymentMechanism) { return 'cardNumber' in paymentMechanism; };
var isApplePayToken = function (paymentMechanism) { return 'paymentSourceId' in paymentMechanism; };
// @TODO: Update this to use ResultCodes from topaz package
var ResultCode;
(function (ResultCode) {
    // See https://apglobal.atlassian.net/wiki/spaces/PAYL/pages/21399554/Result+Codes
    ResultCode[ResultCode["OK"] = 0] = "OK";
    ResultCode[ResultCode["TRANSIENT_GATEWAY_ERROR"] = 1] = "TRANSIENT_GATEWAY_ERROR";
    ResultCode[ResultCode["INVALID_DETAILS"] = 21] = "INVALID_DETAILS";
    ResultCode[ResultCode["DUPLICATE_CARD"] = 22] = "DUPLICATE_CARD";
    ResultCode[ResultCode["EXCEEDED_MAX_ATTEMPTS_ENTERING_DETAILS"] = 23] = "EXCEEDED_MAX_ATTEMPTS_ENTERING_DETAILS";
    ResultCode[ResultCode["INSUFFICIENT_FUNDS"] = 41] = "INSUFFICIENT_FUNDS";
    ResultCode[ResultCode["INVALID_SHIPPING_DETAILS"] = 51] = "INVALID_SHIPPING_DETAILS";
    ResultCode[ResultCode["INVALID_STATE"] = 98] = "INVALID_STATE";
    ResultCode[ResultCode["OTHER_ERROR"] = 99] = "OTHER_ERROR";
    ResultCode[ResultCode["USER_CHALLENGE_FAILED"] = 101] = "USER_CHALLENGE_FAILED";
    ResultCode[ResultCode["UNACCEPTABLE_CARD"] = 61] = "UNACCEPTABLE_CARD";
})(ResultCode || (ResultCode = {}));
var PaymentSourceCaptureCardTypes;
(function (PaymentSourceCaptureCardTypes) {
    PaymentSourceCaptureCardTypes["DEBIT"] = "DEBIT";
    PaymentSourceCaptureCardTypes["CREDIT"] = "CREDIT";
    PaymentSourceCaptureCardTypes["PREPAID"] = "PREPAID";
    PaymentSourceCaptureCardTypes["AFTERPAY"] = "AFTERPAY";
})(PaymentSourceCaptureCardTypes || (PaymentSourceCaptureCardTypes = {}));
var MPANPaymentSourceCaptureCardTypes;
(function (MPANPaymentSourceCaptureCardTypes) {
    MPANPaymentSourceCaptureCardTypes["DEBIT"] = "debit";
    MPANPaymentSourceCaptureCardTypes["CREDIT"] = "credit";
    MPANPaymentSourceCaptureCardTypes["PREPAID"] = "prepaid";
    MPANPaymentSourceCaptureCardTypes["AFTERPAY"] = "afterpay";
})(MPANPaymentSourceCaptureCardTypes || (MPANPaymentSourceCaptureCardTypes = {}));
var ThreeDSecureStatus;
(function (ThreeDSecureStatus) {
    ThreeDSecureStatus[ThreeDSecureStatus["Initiating"] = 0] = "Initiating";
    ThreeDSecureStatus[ThreeDSecureStatus["Initiated"] = 1] = "Initiated";
    ThreeDSecureStatus[ThreeDSecureStatus["Finalising"] = 2] = "Finalising";
    ThreeDSecureStatus[ThreeDSecureStatus["Finalised"] = 3] = "Finalised";
    ThreeDSecureStatus[ThreeDSecureStatus["Error"] = 4] = "Error";
})(ThreeDSecureStatus || (ThreeDSecureStatus = {}));
var ThreeDSChallengeStatus;
(function (ThreeDSChallengeStatus) {
    ThreeDSChallengeStatus[ThreeDSChallengeStatus["Pending"] = 0] = "Pending";
    ThreeDSChallengeStatus[ThreeDSChallengeStatus["ChallengeNotRequired"] = 1] = "ChallengeNotRequired";
    ThreeDSChallengeStatus[ThreeDSChallengeStatus["ChallengeRequired"] = 2] = "ChallengeRequired";
})(ThreeDSChallengeStatus || (ThreeDSChallengeStatus = {}));
var ThreeDSWorkflows;
(function (ThreeDSWorkflows) {
    ThreeDSWorkflows["CHECKOUT"] = "CHECKOUT";
    ThreeDSWorkflows["PAYNOW"] = "PAYNOW";
    ThreeDSWorkflows["BILLING"] = "BILLING";
})(ThreeDSWorkflows || (ThreeDSWorkflows = {}));
var InitiateThreeDSErrorCode;
(function (InitiateThreeDSErrorCode) {
    InitiateThreeDSErrorCode[InitiateThreeDSErrorCode["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    InitiateThreeDSErrorCode[InitiateThreeDSErrorCode["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
})(InitiateThreeDSErrorCode || (InitiateThreeDSErrorCode = {}));
var FinaliseThreeDSErrorCode;
(function (FinaliseThreeDSErrorCode) {
    FinaliseThreeDSErrorCode[FinaliseThreeDSErrorCode["USER_CHALLENGE_FAILED"] = 402] = "USER_CHALLENGE_FAILED";
})(FinaliseThreeDSErrorCode || (FinaliseThreeDSErrorCode = {}));

export { FinaliseThreeDSErrorCode, InitiateThreeDSErrorCode, MPANPaymentSourceCaptureCardTypes, PaymentMethodType, PaymentSourceCaptureCardTypes, PaymentType, ResultCode, ThreeDSChallengeStatus, ThreeDSWorkflows, ThreeDSecureStatus, TopazStatus, isApplePayToken, isNewCard, isSavedCard };
